import { FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Spinner from '@components/Spinner';
import { routesConfig } from './routes';

const AppRoutes: FC = () => (
  <Suspense fallback={<Spinner />}>
    <Routes>
      {routesConfig.map(({ path, element: Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}
    </Routes>
  </Suspense>
);

export default AppRoutes;
